import { z } from 'zod';

/**
 * A character's Grimoire (MAGIC-GRIMOIRE, MU-6) and its slots' choices (WT-2): the spells it
 * learned, in order, and what it put in its slots: per weapon family its Q and E, and its magic of
 * R to X. A null leaves a slot to the default (the first opened, the first learned).
 */
export const GrimoireViewSchema = z.object({
  spells: z.array(z.string()),
  loadout: z.object({
    weapon: z.record(z.string(), z.array(z.string().nullable())),
    magic: z.array(z.string().nullable()),
  }),
});
export type GrimoireView = z.infer<typeof GrimoireViewSchema>;
